import React, { Component, Fragment } from 'react';
import { Route, Switch, Link, Redirect } from 'react-router-dom'

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';

import PageCalendar from "./pages/PageCalendar.js"
import PageGlobalTodo from "./pages/PageGlobalTodo.js"

class App extends Component {

  render() {

    return (
      <Container>
        <Box p={3}>
          <Typography component="h1" variant="h4" align="center">Eleanor Planner</Typography>
        </Box>

        <Route path="/" render={({ location }) => (
            <Fragment>
              <AppBar position="static">
                <Tabs variant="fullWidth" value={location.pathname}>
                  <Tab label="Calendar" value="/calendar" component={Link} to="/calendar" />
                  <Tab label="Todo" value="/todo" component={Link} to="/todo" />
                </Tabs>
              </AppBar>

              <Box p={2}>
                <Typography variant="h5" align="center">{location.pathname.charAt(1).toUpperCase() + location.pathname.substr(2)}</Typography>
              </Box>

              <Box>
                <Switch>
                  <Route path="/calendar" component={PageCalendar} />
                  <Route path="/todo" render={PageGlobalTodo} />
                  <Redirect from="/" to="/calendar" />
                </Switch>
              </Box>
            </Fragment>
          )}
        />

      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js